module.exports = __webpack_public_path__ + "media/images/client-9-f5da872e4e007c0cc9bb54751d131bb1.png";